import {
  INFO_PROFILE_FETCH_REQUEST,
  INFO_PROFILE_FETCH_SUCCESS,
  INFO_PROFILE_FETCH_FAILURE,
} from "./actionTypes"

const INIT_STATE = {
  profile: null,
  topics: [],
  posts: [],
  loading: false,
  error: null,
}

const infoProfileReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INFO_PROFILE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case INFO_PROFILE_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload.profile,
        topics: action.payload.topics,
        posts: action.payload.posts,
      };

    case INFO_PROFILE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case "INFO_PROFILE_UPDATE_IMAGE":
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload, // { profileImage } or { backgroundImage }
        },
      };

    case "INFO_PROFILE_UPDATE_TEXT":
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload, // { displayName } or { bio }
        },
      };

    case "INFO_PROFILE_ADD_TOPIC":
      return {
        ...state,
        topics: [...state.topics, action.payload],
      };
      
    default:
      return state;
  }
};

export default infoProfileReducer;




